import * as React from "react";
import { makeStyles, Button, Dropdown, Option } from "@fluentui/react-components";
import { Settings24Regular } from "@fluentui/react-icons";
import GradientBar from "./shared/GradientBar";
import { PERSONAS, PERSONA_WORKFLOW_CATALOG } from "../../shared/constants";

const useStyles = makeStyles({
  wrapper: { flexShrink: 0 },
  header: {
    display: "flex",
    alignItems: "center",
    height: "48px",
    padding: "0 12px",
    backgroundColor: "var(--bg-primary, #FFFFFF)",
    gap: "6px",
  },
  title: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "1.35",
    flexShrink: 0,
    fontFamily: "'Avenir Next LT Pro Demi','Avenir Next',sans-serif",
    display: "flex",
    gap: "2px",
    alignItems: "center",
  },
  spacer: { flex: 1 },
  personaDropdown: { minWidth: "110px", maxWidth: "130px" },
  workflowDropdown: { minWidth: "130px", maxWidth: "170px" },
  gearButton: { minWidth: "32px", width: "32px", height: "32px", padding: "0" },
});

/**
 * Compact IAN header.
 * Adds a Workflow dropdown next to the Persona dropdown so users can pick
 * which DAG runs (default + persona-defined + their custom workflows).
 */
const IanHeader = ({
  persona,
  onPersonaChange,
  activeWorkflowId,
  onWorkflowChange,
  customWorkflows = [],
  onSettingsClick,
}) => {
  const styles = useStyles();

  const builtinWorkflows = PERSONA_WORKFLOW_CATALOG[persona] || [];
  const allWorkflows = [
    { id: "", name: "Default (auto)" },
    ...builtinWorkflows,
    ...customWorkflows.map((w) => ({ id: w.id, name: `★ ${w.name}` })),
  ];

  const activeLabel =
    allWorkflows.find((w) => w.id === (activeWorkflowId || ""))?.name || "Default (auto)";

  return (
    <div className={styles.wrapper}>
      <GradientBar />
      <div className={styles.header}>
        <img src="../../../assets/apple-touch-icon.png" height="28" width="28" alt="IAN" />
        <span className={styles.title}>
          <span style={{ background: "linear-gradient(to bottom,#FFB500,#FF743C,#FF5757)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>I</span>
          <span style={{ background: "linear-gradient(to right,#FFB500,#FF5757,#4B90BF,#2E9AD0)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>A</span>
          <span style={{ background: "linear-gradient(to right,#00A9EB,#5DCC7D)", WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" }}>N</span>
        </span>
        <div className={styles.spacer} />
        <Dropdown
          className={styles.personaDropdown}
          value={PERSONAS.find((p) => p.key === persona)?.label || "Persona"}
          onOptionSelect={(_, data) => onPersonaChange(data.optionValue)}
          size="small"
          appearance="underline"
        >
          {PERSONAS.map((p) => (
            <Option key={p.key} value={p.key}>
              {p.label}
            </Option>
          ))}
        </Dropdown>
        <Dropdown
          className={styles.workflowDropdown}
          value={activeLabel}
          onOptionSelect={(_, data) => onWorkflowChange(data.optionValue)}
          size="small"
          appearance="underline"
        >
          {allWorkflows.map((w) => (
            <Option key={w.id || "default"} value={w.id}>
              {w.name}
            </Option>
          ))}
        </Dropdown>
        <Button
          className={styles.gearButton}
          appearance="subtle"
          icon={<Settings24Regular />}
          onClick={onSettingsClick}
          aria-label="Settings"
          size="small"
        />
      </div>
    </div>
  );
};

export default IanHeader;
